<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "VendaContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
		drawer: false,
		group: null,
		value: 0,
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("produto_listar")) {
				m.push({
					titulo: "* Tele-vendas",
					titulo_app: "Vendas",
					icon: "mdi-shopping-outline",
					to: "/venda",
					tooltip: "Tele-vendas de produtos",
				});
			}

			if (this.permissao("pedido_listar")) {
				m.push({
					titulo: "Pedidos",
					titulo_app: "Pedidos",
					icon: "mdi-file-document-outline",
					to: "/venda/pedido",
					tooltip: "Lista de pedidos de clientes",
				});
			}

			if (this.permissao("orcamento_listar")) {
				m.push({
					titulo: "Orçamentos",
					titulo_app: "Orçamentos",
					icon: "mdi-file-document",
					to: "/venda/orcamento",
					tooltip: "Lista de orçamentos de clientes",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>